import { useState, useEffect } from "react";
import { useStore } from "../../../../../../hooks";
import { MESSAGES_CHAT_URL } from "../constants";

const DEFAULT_AGENT_DATA = {
  name: "Strategy Assistant",
  description:
    "I can help you streamline your work focused on your goals. If you'd like, ask me something to get started.",
  metadata: {
    model: "GPT 5.2",
  },
};

export const useChatPanelData = (selectedConversationId, selectedAgentId) => {
  const { chatStore } = useStore();
  const [messages, setMessages] = useState([]);

  // Cargar información del agente cuando se selecciona un agente directamente
  useEffect(() => {
    if (selectedAgentId && !chatStore.selectedAgent) {
      chatStore.setSelectedAgentData({
        name: selectedAgentId,
        description: DEFAULT_AGENT_DATA.description,
        metadata: DEFAULT_AGENT_DATA.metadata,
      });
    }
  }, [selectedAgentId, chatStore]);

  // Cargar mensajes y agente cuando se selecciona una conversación
  useEffect(() => {
    if (!selectedConversationId) {
      setMessages([]);
      return;
    }
    const loadMessages = async () => {
      try {
        const res = await fetch(MESSAGES_CHAT_URL);
        const data = await res.json();
        const list = Array.isArray(data) ? data : [];
        const conv = list.find((c) => c.conversation_uuid === selectedConversationId);
        setMessages(conv?.messages ?? []);

        if (!chatStore.selectedAgent) {
          chatStore.setSelectedAgentData(DEFAULT_AGENT_DATA);
        }
      } catch {
        setMessages([]);
      }
    };
    loadMessages();
  }, [selectedConversationId, chatStore]);

  return { messages };
};
